let appConfig = null;
export function setAppConfig(newAppConfig) {
    appConfig = newAppConfig;
}
export function getAppConfig() {
    return appConfig;
}
